import React from 'react';
import { ServiceTemplate } from '../ServiceTemplate';
import { companyFormationData } from '../../servicesData';

export const CompanyFormation = ({ onOpenPopup }) => {
  return (
    <ServiceTemplate
      service={companyFormationData}
      onOpenPopup={onOpenPopup}
      showPricing={false}
    />
  );
};